import Vuex from 'vuex'
import navbar from './modules/navbar.store'
import manageClient from './modules/manageClient.store'
import manageClientDocuments from './modules/manageClientDocument.store'
import manageUsers from './modules/manageUsers.store'
import global from './modules/global.store'
import adminSettings from './modules/adminSettings.store'
import manageUserGroups from './modules/manageUserGroups.store'
import manageRoles from './modules/manageRoles.store'
import oktaGroups from './modules/oktaGroups.store'
import oktaUsers from './modules/oktaUsers.store'
import oktaFederations from './modules/oktaFederations.store'
import http from 'axios'

http.interceptors.request.use(
  function(config) {
    store.commit('global/setShowValidationMessage', false, { root: true })
    return config
  },
  undefined
)

http.interceptors.response.use(
  undefined,
  function(error) {
    if (error.response.status === 401) {
      store.commit('global/setShowUnauthorizedMessage', true, { root: true })
    } else if (error.response.status === 422) {
      error.response.data.forEach(er => {
        if (!er.args) er.args = []
        er.message = er.message.replace(/(%%|%s)/g, match => match === '%%' ? '%' : er.args.shift())
      })
      store.commit('global/setShowValidationMessage', error.response.data, { root: true })
    }
    return Promise.reject(error)
  }
)

const store = new Vuex.Store({
  modules: {
    navbar,
    manageClient,
    manageClientDocuments,
    adminSettings,
    manageRoles,
    manageUsers,
    global,
    manageUserGroups,
    oktaGroups,
    oktaUsers,
    oktaFederations
  },
  // Strict mode should not be enabled in production as it runs a deep watch on mutations
  /* eslint-disable no-undef */
  strict: ((typeof strictVuex === 'boolean' && strictVuex !== false) ||
    typeof strictVuex === 'undefined') && process.env.NODE_ENV !== 'production'
})

export default store
